import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    sortLabel: {
        "& svg": {
            color: theme.palette.emteria.text.inverse + " !important",
        },
        fontWeight: 500,
    },
    badge: {
        marginLeft: theme.spacing(3),
        alignSelf: "center",
        transform: "translateY(-1px)",
        color: theme.palette.emteria.indicator,
    },

    typeCell: {
        width: "50px !important",
    },
    withPointer: {
        cursor: "pointer",
    },
}));
